import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=5500d37c&scoped=true"
import script from "./ColorPicker.vue?vue&type=script&lang=js"
export * from "./ColorPicker.vue?vue&type=script&lang=js"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=5500d37c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5500d37c",
  null
  
)

export default component.exports